import { i18n } from 'i18n/config';

export const NotificationType = {
  NORMAL: 'normal',
  SILENT: 'silent',
  CRITICAL: 'critical',
} as const;

export const NotificationSettingTypes = {
  all: 'all',
  onlyNew: 'new_incidents_only',
  off: 'off',
  allWithSilent: 'all_with_silent',
  onlyNewWithSilent: 'only_new_with_silent',
} as const;

// Rank the user region settings from most coverage to least
export const NotificationSettingTypesCoverageOrder = [
  NotificationSettingTypes.allWithSilent,
  NotificationSettingTypes.all,
  NotificationSettingTypes.onlyNewWithSilent,
  NotificationSettingTypes.onlyNew,
  NotificationSettingTypes.off,
];

// Enum's of subscription settings possible for a region
// todo: update to typed with the key mapping pulling from NotificationOption
export const NotificationTypes = {
  ALL: {
    displayName: i18n.t('notifications.types.all'),
    key: NotificationSettingTypes.all,
  },
  NEW_INCIDENTS_ONLY: {
    displayName: i18n.t('notifications.types.first'),
    key: NotificationSettingTypes.onlyNew,
  },
  OFF: {
    displayName: i18n.t('notifications.types.off'),
    key: NotificationSettingTypes.off,
  },
} as const;

export const NOTIFICATIONS_SETTINGS_QUERY_KEY = 'notificationSettings';
export const NOTIFICATIONS_REGIONS_QUERY_KEY = 'allRegions';
export const SINGLE_TOPIC_NOTIFICATION_QUERY_KEY = 'subscribedTopics';

export const NOTIFICATIONS_CACHE_TIME = 1000 * 60 * 60 * 24 * 21; // 3 weeks - gcTime can't be more than 24 days
export const SINGLE_TOPIC_CACHE_TIME_LOGGED_OUT = 1000 * 60 * 60 * 24 * 21; // 3 weeks - gcTime can't be more than 24 days
export const SINGLE_TOPIC_CACHE_TIME_LOGGED_IN = 1000 * 60 * 60; // 1 hour
